import React from 'react';
import { Box, Typography, Stack, CircularProgress, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MatchCard from './MatchCard';
import { SportsEsports as GameIcon } from '@mui/icons-material';

const RecentMatchesSection = ({ 
  matches, 
  usersMap, 
  userId, 
  isLoading, 
  showOnlyApproved = false,
  hideTitle = false,
  showMyMatchesLink = false
}) => {
  const navigate = useNavigate();

  const filteredMatches = matches.filter(match => {
    const team1Players = match.team1?.players || [];
    const team2Players = match.team2?.players || [];
    
    const userInMatch = team1Players.some(p => p.user_id === userId) ||
                       team2Players.some(p => p.user_id === userId);

    if (!showOnlyApproved) {
      return userInMatch;
    }

    // For approved matches, check if all players have approved
    const allPlayersApproved = [...team1Players, ...team2Players]
      .every(p => p.approval_status === 'approved');

    return userInMatch && allPlayersApproved;
  });

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      {!hideTitle && (
        <Typography 
          variant="h6" 
          sx={{ 
            mb: 2,
            color: 'text.secondary',
            fontWeight: 'bold'
          }}
        >
          Mis Partidas Recientes
        </Typography>
      )}
      <Stack spacing={2}>
        {filteredMatches.map((match) => (
          <MatchCard
            key={match.id}
            match={match}
            usersMap={usersMap}
            onClick={() => navigate(`/match/${match.id}`)}
          />
        ))}
        {filteredMatches.length === 0 && (
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            gap: 1
          }}>
            <GameIcon sx={{ fontSize: 40, color: 'text.disabled' }} />
            <Typography color="text.secondary">
              No has participado en ninguna partida o aún no fue aprobada
            </Typography>
            {showMyMatchesLink && (
              <Button
                variant="outlined"
                size="small"
                onClick={() => navigate('/my-matches')}
                sx={{
                  borderRadius: 1.5,
                  textTransform: 'none',
                  fontSize: '0.85rem',
                  mt: 1
                }}
              >
                Ver Mis Partidas
              </Button>
            )}
          </Box>
        )}
      </Stack>
    </Box>
  );
};

export default RecentMatchesSection; 